export default __webpack_public_path__ + "static/media/location-map.cf7f4a74.webp";